import { useCallback, useEffect, useState } from 'react';

import { SubtitlesRatio, sideShortSizeMode } from './Subtitles.types';
import { getScreenInfo } from './helpers';

const PADDING_COEF = 8;
const LINE_HEIGHT_COEF = 8;

export const useSubtitlesSize = (ratio: SubtitlesRatio) => {
    const [fontSize, setFontSize] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);
    const [padding, setPadding] = useState(0);

    const handleResize = useCallback(() => {
        const { screenCoef, shortSideSize, sizeMode } = getScreenInfo();
        const currentFontSize = (screenCoef / 100) * shortSideSize * ratio;
        const currentPadding =
            sizeMode === sideShortSizeMode.NORMAL ? PADDING_COEF : PADDING_COEF / 2;
        const lineHeightAdditional =
            sizeMode === sideShortSizeMode.NORMAL ? LINE_HEIGHT_COEF : LINE_HEIGHT_COEF / 2;

        setLineHeight(currentFontSize + lineHeightAdditional);
        setFontSize(currentFontSize);
        setPadding(currentPadding);
    }, [ratio]);

    useEffect(() => {
        handleResize();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [handleResize]);

    return [fontSize, padding, lineHeight];
};
